import clsx from 'clsx'
import SharedScenarioItem, { IScenarioInfo } from 'components/SharedScenarioItem/SharedScenarioItem'
import { useTranslation } from 'react-i18next'

import style from './ScenarioTable.module.css'

const ScenarioTable = ({
  scenarios,
  highlightedScenarioId,
  onScenarioClick,
  onLaunchScenario,
  onScenariosUpdated,
  className,
}: {
  scenarios: IScenarioInfo[]
  highlightedScenarioId?: number
  onScenarioClick?: (id: number, missionIds: Array<number | string>) => void
  onLaunchScenario?: (scenario: IScenarioInfo) => void
  onScenariosUpdated: () => void
  className?: string
}) => {
  const { t } = useTranslation()

  return (
    <div className={clsx(style.root, className)}>
      <div className={style.tableHeader}>
        <span></span>
        <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.id')}</div>
        <div className={clsx(style.tableHeaderItem, 'text-16-400')}>{t('missions.name')}</div>
        <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Missions</div>
        <div className={clsx(style.tableHeaderItemSmall, 'text-16-400')}>Robot type</div>
        <div className={style.tableHeaderItemSmall} />
      </div>
      {scenarios.length > 0 ? (
        <div className={style.table}>
          {scenarios.map(scenario => (
            <SharedScenarioItem
              key={scenario.id}
              scenario={scenario}
              highlighted={highlightedScenarioId === scenario.id}
              onClick={() => onScenarioClick?.(scenario.id, scenario.missions_ids ?? [])}
              onLaunch={onLaunchScenario}
              onScenariosUpdated={onScenariosUpdated}
            />
          ))}
        </div>
      ) : (
        <div className={style.emptyWrapper}>
          <div className={style.emptyTitle}>No scenarios found</div>
        </div>
      )}
    </div>
  )
}

export default ScenarioTable
